(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  if (window.initializeChosen) {
    window.initializeChosen()
  }

  const forms = $('form.validate')

  forms.each((i, form) => {
    const $form = $(form)

    $form.validate({
      errorClass: 'error input-error',
      errorElement: 'span',
      ignore: '', // Don't ignore hidden fields (chosen)

      errorPlacement: ($error, $element) => {
        let $errorElement = $element
        if ($element.is('select')) {
          $errorElement = $element.siblings('.chosen-container')
        }

        $error.insertAfter($errorElement)
        $errorElement.addClass('error')
      },

      success: (error, element) => {
        const $element = $(element)

        let $errorElement = $element
        if ($element.is('select')) {
          $errorElement = $element.siblings('.chosen-container')
        }

        error.remove()
        $errorElement.removeClass('error')
      }
    })

  })
})

$('select').change(function () {
    $(this).valid()
})

$.validator.addMethod(
  'regex',
  function (value, element, regexp) {
    let re = new RegExp(regexp)
    return this.optional(element) || re.test(value)
  },
  window.notValidError || 'Not valid'
)

$(() => {
  $('input[name=phone]').rules('add', { regex: '^\\+?(\\d|\\s){8,100}$' })
})

$(() => {
  const $body = $('body')

  const getMessage = (identifier) => {
    if (!$body.attr(`data-msg-${identifier}`)) {
      console.error(`Missing translation-data on body-element: data-msg-${identifier}="···"`)
    }

    return $body.data(`msg-${identifier}`)
  }

  $.extend($.validator.messages, {
    required: getMessage('required'),
    email: getMessage('email')
  })
})

$(() => {
  const $forms = $('form[data-form-action]')

  $forms.each((i, form) => {
    const $form = $(form)

    $form.on('submit', () => {
      if ($form.hasClass('validate') && !$form.valid()) {
        return // Only submit valid forms
      }

      const $formElement = $form.find('.form')
      const $workIndicatorElement = $form.find('.work-indicator')
      const $successElement = $form.find('.success')

      $formElement.hide()
      $workIndicatorElement.show()

      const formData = $form.serialize()

      $.ajax({
        type: 'POST',
        url: $form.data('form-action'),
        data: formData,
        success: () => {
          const redirectUrl = $form.data('form-success-redirect')
          if (!(redirectUrl == null)) {
            window.location = redirectUrl
          } else {
            $workIndicatorElement.hide()
            $successElement.show()
          }
        }
      }).fail(() => { // This should never happen
        $workIndicatorElement.hide()
        $formElement.show()
        window.alert('Error - please try again')
      })

      // Prevent default behaviour
      return false
    })
  })
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_form.js","/")